module.exports = __webpack_public_path__ + "img/SanFrsc_MosconeCntr_to_TheWestinSt_WalkingMap.29d5929d.png";